
import Vue from 'vue'
import Plant from '@/models/Plant'

import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'

import { sortAlpha } from '@/helpers/sorters'

function sortUprooted(next?: (a: Plant, b: Plant) => number) {
  return (a: Plant, b: Plant) =>
    a.isActive && !b.isActive
      ? -1
      : !a.isActive && b.isActive
      ? 1
      : next
      ? next(a, b)
      : 0
}
// const sortUprooted = (a: Plant, b: Plant) => a.isActive > b.isActive ? 1 : -1

export default Vue.extend({
  components: {
    PlantAvatar,
  },
  props: {
    gardenId: String,
    verticalTabs: Boolean,
  },
  computed: {
    plants(): Plant[] {
      return (
        this.$store.getters['gardens/plants/inGarden'](this.gardenId)
          .slice()
          // .sort(sortAlpha<Plant>('abbr', sortAlpha<Plant>('name')))
          .sort(
            sortUprooted(sortAlpha<Plant>('abbr', sortAlpha<Plant>('name')))
          )
      )
    },
    activePlants(): Plant[] {
      return this.plants.filter(
        (p) => p.isActive || this.selectedPlantId === p.id
      )
    },
    inactivePlants(): Plant[] {
      return this.plants.filter((p) => !p.isActive)
    },
    selectedPlantId(): string | undefined {
      return this.$route.params.plantId
    },
  },
})
